/*!
 * Copyright © 2020. Verizon Connect Ireland Limited. All rights reserved.
 */
import { NgModule } from '@angular/core';

import { EPlotIcon } from '../core/models';
import { IIconNamePathPair } from '../core/models/icon-name-path-pair.interface';
import { CompoundIconRegistryService, IconOffsetParams, MapIconRegistryService } from '../core/services';

const icTree = 'assets/images/vehicle-driver-panel/ic-tree.svg';
const icVehicle = 'assets/images/vehicle-driver-panel/ic-vehicle.svg';
const icDriver = 'assets/images/vehicle-driver-panel/ic-driver.svg';
const icSort = 'assets/images/vehicle-driver-panel/ic-sort.svg';
const icElectricVehicleBadge = 'assets/images/vehicle-driver-panel/ic-electric-vehicle-badge.svg';
const icDispatch = 'assets/images/fabs/ic-driver-dispatch.svg';
const icWarning = 'assets/images/plots/ic-plot-panic.svg';
const icPanic = 'assets/images/plots/ic-plot-panic.svg';
const icStop = 'assets/images/plots/ic-plot-stop.svg';
const icIdle = 'assets/images/plots/ic-plot-idle.svg';
const icMovingE = 'assets/images/plots/ic-plot-moving-e.svg';
const icMovingN = 'assets/images/plots/ic-plot-moving-n.svg';
const icMovingNE = 'assets/images/plots/ic-plot-moving-ne.svg';
const icMovingNW = 'assets/images/plots/ic-plot-moving-nw.svg';
const icMovingS = 'assets/images/plots/ic-plot-moving-s.svg';
const icMovingSE = 'assets/images/plots/ic-plot-moving-se.svg';
const icMovingSW = 'assets/images/plots/ic-plot-moving-sw.svg';
const icMovingW = 'assets/images/plots/ic-plot-moving-w.svg';
const icPrivate = 'assets/images/plots/ic-plot-private.svg';
const icNoVehicleSelected = 'assets/images/vehicle-status/no-vehicle.svg';
const icTowing = 'assets/images/plots/ic-plot-towing.svg';
const icLs = 'assets/images/plots/ic-plot-ls.svg';
const icSignalMessage = 'assets/images/vehicle-status/ic-signal-strength-message.svg';
const icSignalLow = 'assets/images/vehicle-status/ic-signal-strength-low.svg';
const icSignalLost = 'assets/images/vehicle-status/ic-signal-strength-loss.svg';
const icSignalNormal = 'assets/images/vehicle-status/ic-signal-strength-normal.svg';
const icNoMoving = 'assets/images/vehicle-status/ic-no-moving.svg';
const icNoIdling = 'assets/images/vehicle-status/ic-no-idling.svg';
const icNoStopped = 'assets/images/vehicle-status/ic-no-stopped.svg';
const icNoCharging = 'assets/images/vehicle-status/ic-no-charging.svg';
const icNoFleetSelected = 'assets/images/vehicle-status/ic-no-fleet-selected.svg';
const icNoFleetConnected = 'assets/images/vehicle-status/ic-no-fleet-connected.svg';
const icBolt = 'assets/images/vehicle-status/ic-bolt.svg';
const icCharging = 'assets/images/vehicle-status/ic-charging.svg';
const icCharging0 = 'assets/images/vehicle-status/ic-charging0.svg';
const icCharging10 = 'assets/images/vehicle-status/ic-charging10.svg';
const icCharging20 = 'assets/images/vehicle-status/ic-charging20.svg';
const icCharging30 = 'assets/images/vehicle-status/ic-charging30.svg';
const icCharging40 = 'assets/images/vehicle-status/ic-charging40.svg';
const icCharging50 = 'assets/images/vehicle-status/ic-charging50.svg';
const icCharging60 = 'assets/images/vehicle-status/ic-charging60.svg';
const icCharging70 = 'assets/images/vehicle-status/ic-charging70.svg';
const icCharging80 = 'assets/images/vehicle-status/ic-charging80.svg';
const icCharging90 = 'assets/images/vehicle-status/ic-charging90.svg';
const icCharging99 = 'assets/images/vehicle-status/ic-charging99.svg';
const icCustomerCare = 'assets/images/plots/ic-plot-customer-care.svg';
const icLocationPin = 'assets/images/plots/ic-location-pin.svg';
const icWtdAvailability = 'assets/images/driver-status/ic-wtd-availability.svg';
const icWtdBreakDue = 'assets/images/driver-status/ic-wtd-break-due.svg';
const icWtdDriving = 'assets/images/driver-status/ic-wtd-driving.svg';
const icWtdOtherWork = 'assets/images/driver-status/ic-wtd-other-work.svg';
const icWtdResting = 'assets/images/driver-status/ic-wtd-resting.svg';
const icNoDriversMatchFilter = 'assets/images/driver-status/no-drivers.svg';
const icRead = 'assets/images/scheduler/ic-read.svg';
const icReceived = 'assets/images/scheduler/ic-received.svg';
const icSent = 'assets/images/scheduler/ic-sent.svg';
const ic0 = 'assets/images/plots/ic-plot-0.svg';
const icAlarmClock = 'assets/images/plots/ic-plot-AlarmClock.svg';
const icBoxClosed = 'assets/images/plots/ic-plot-BoxClosed.svg';
const icBox = 'assets/images/plots/ic-plot-Box.svg';
const icBrickwall = 'assets/images/plots/ic-plot-Brickwall.svg';
const icFilm = 'assets/images/plots/ic-plot-Film.svg';
const icFactory = 'assets/images/plots/ic-plot-Factory.svg';
const icEarth = 'assets/images/plots/ic-plot-Earth.svg';
const icCourthouse = 'assets/images/plots/ic-plot-Courthouse.svg';
const icChest = 'assets/images/plots/ic-plot-Chest.svg';
const icFire = 'assets/images/plots/ic-plot-Fire.svg';
const icFlagRed = 'assets/images/plots/ic-plot-FlagRed.svg';
const icFlagGreen = 'assets/images/plots/ic-plot-FlagGreen.svg';
const icFlagYellow = 'assets/images/plots/ic-plot-FlagYellow.svg';
const icFlagBlue = 'assets/images/plots/ic-plot-FlagBlue.svg';
const icKey = 'assets/images/plots/ic-plot-Key.svg';
const icFirstAid = 'assets/images/plots/ic-plot-FirstAid.svg';
const icMailboxEmpty = 'assets/images/plots/ic-plot-MailboxEmpty.svg';
const icLock = 'assets/images/plots/ic-plot-Lock.svg';
const icHouses = 'assets/images/plots/ic-plot-Houses.svg';
const icHome = 'assets/images/plots/ic-plot-Home.svg';
const icHelicopter = 'assets/images/plots/ic-plot-Helicopter.svg';
const icGraduate = 'assets/images/plots/ic-plot-Graduate.svg';
const icFortress = 'assets/images/plots/ic-plot-Fortress.svg';
const icForklifter = 'assets/images/plots/ic-plot-Forklifter.svg';
const icPinYellow = 'assets/images/plots/ic-plot-Pin_Yellow.svg';
const icPinRed = 'assets/images/plots/ic-plot-Pin_Red.svg';
const icPinOrange = 'assets/images/plots/ic-plot-Pin_Orange.svg';
const icPinBlue = 'assets/images/plots/ic-plot-Pin_Blue.svg';
const icPinGrey = 'assets/images/plots/ic-plot-Pin_Grey.svg';
const icPinGreen = 'assets/images/plots/ic-plot-Pin_Green.svg';
const icPillYellow = 'assets/images/plots/ic-plot-PillYellow.svg';
const icPillRed = 'assets/images/plots/ic-plot-PillRed.svg';
const icPillGreen = 'assets/images/plots/ic-plot-PillGreen.svg';
const icPillBlue = 'assets/images/plots/ic-plot-PillBlue.svg';
const icPawn = 'assets/images/plots/ic-plot-Pawn.svg';
const icPawnYellow = 'assets/images/plots/ic-plot-PawnYellow.svg';
const icPawnWhite = 'assets/images/plots/ic-plot-PawnWhite.svg';
const icPawnRed = 'assets/images/plots/ic-plot-PawnRed.svg';
const icPawnGreen = 'assets/images/plots/ic-plot-PawnGreen.svg';
const icPawnBlue = 'assets/images/plots/ic-plot-PawnBlue.svg';
const icNews = 'assets/images/plots/ic-plot-News.svg';
const icMoneybag = 'assets/images/plots/ic-plot-Moneybag.svg';
const icWorker = 'assets/images/plots/ic-plot-Worker.svg';
const icMobilePhone = 'assets/images/plots/ic-plot-MobilePhone.svg';
const icTarget = 'assets/images/plots/ic-plot-Target.svg';
const icStarYellow = 'assets/images/plots/ic-plot-StarYellow.svg';
const icStarRed = 'assets/images/plots/ic-plot-StarRed.svg';
const icStarGrey = 'assets/images/plots/ic-plot-StarGrey.svg';
const icStarGreen = 'assets/images/plots/ic-plot-StarGreen.svg';
const icStarBlue = 'assets/images/plots/ic-plot-StarBlue.svg';
const icShoppingcart = 'assets/images/plots/ic-plot-Shoppingcart.svg';
const icSignpost = 'assets/images/plots/ic-plot-Signpost.svg';
const icServer = 'assets/images/plots/ic-plot-Server.svg';
const icSatelliteDish = 'assets/images/plots/ic-plot-SatelliteDish.svg';
const icSafe = 'assets/images/plots/ic-plot-Safe.svg';
const icPlayingcard = 'assets/images/plots/ic-plot-Playingcard.svg';
const icHouse = 'assets/images/plots/ic-plot-House.svg';
const icUncategorized = 'assets/images/plots/ic-plot-Uncategorized.svg';
const icHotSpot = 'assets/images/plots/ic-plot-hotSpot.svg';
const icGarminIconPending = 'assets/images/plots/ic-plot-garminIcon-pending.svg';
const icGarminIconEnRoute = 'assets/images/plots/ic-plot-garminIcon-enRoute.svg';
const icGarminIconCompleted = 'assets/images/plots/ic-plot-garminIcon-completed.svg';
const icHarshDrivingEvent = 'assets/images/plots/ic-plot-harsh-driving-event.svg';
const icCopy = 'assets/images/directions/ic-copy.svg';
const icStopPoweredAsset = 'assets/images/plots/ic-plot-stop-powered-asset.svg';
const icIdlePoweredAsset = 'assets/images/plots/ic-plot-idle-powered-asset.svg';
const icMovingEPoweredAsset = 'assets/images/plots/ic-plot-moving-e-powered-asset.svg';
const icMovingNPoweredAsset = 'assets/images/plots/ic-plot-moving-n-powered-asset.svg';
const icMovingNEPoweredAsset = 'assets/images/plots/ic-plot-moving-ne-powered-asset.svg';
const icMovingNWPoweredAsset = 'assets/images/plots/ic-plot-moving-nw-powered-asset.svg';
const icMovingSPoweredAsset = 'assets/images/plots/ic-plot-moving-s-powered-asset.svg';
const icMovingSEPoweredAsset = 'assets/images/plots/ic-plot-moving-se-powered-asset.svg';
const icMovingSWPoweredAsset = 'assets/images/plots/ic-plot-moving-sw-powered-asset.svg';
const icMovingWPoweredAsset = 'assets/images/plots/ic-plot-moving-w-powered-asset.svg';
const icTowingPoweredAsset = 'assets/images/plots/ic-plot-towing-powered-asset.svg';
const icLsPoweredAsset = 'assets/images/plots/ic-plot-ls-powered-asset.svg';
const icCustomerCarePoweredAsset = 'assets/images/plots/ic-plot-customer-care-powered-asset.svg';
const icCloseWhiteWithBackground = 'assets/images/buttons/ic-close-white-with-background.svg';
const icVideoPlayButton = 'assets/images/buttons/ic-video-play-button.svg';
const icNonPoweredAssetLocationCheckIn = 'assets/images/plots/ic-plot-asset.svg';
const icNonPoweredAssetMovingNe = 'assets/images/plots/ic-plot-moving-ne-npa.svg';
const icNonPoweredAssetStopped = 'assets/images/plots/ic-plot-stop-non-powered-asset.svg';
const icReplayBalloonBatteryRange = 'assets/images/balloons/ic-replay-balloon-battery-range.svg';
const icReplaySegmentBatteryRange = 'assets/images/replay/ic-replay-segment-battery-range.svg';
const icReplaySegmentBatteryRangeInfo = 'assets/images/replay/ic-replay-segment-battery-range-info.svg';
const icReplaySegmentBolt = 'assets/images/replay/ic-replay-segment-bolt.svg';
const icLink = 'assets/images/device-health-check/ic-link.svg';
const icHealthStatusCritical = 'assets/images/device-health/ic-health-status-critical.svg';
const deviceIssue = 'assets/images/device-health/device-issue.svg';
const icDeviceWithErrorLegend = 'assets/images/device-health/ic-device-error-legend.svg';
const icNoDeviceError = 'assets/images/device-health/ic-no-device-error.svg';

@NgModule()
export class MapsIconModule {
  private readonly _iconHealthStatusName = 'device-issue';
  private readonly _icons: IIconNamePathPair[] = [
    { name: 'tree', svg: icTree },
    { name: 'vehicle', svg: icVehicle },
    { name: 'driver', svg: icDriver },
    { name: 'sort', svg: icSort },
    { name: 'electric-vehicle-badge', svg: icElectricVehicleBadge },
    { name: 'dispatch', svg: icDispatch },
    { name: 'warning', svg: icWarning },
    { name: EPlotIcon.Panic, svg: icPanic },
    { name: EPlotIcon.Stopped, svg: icStop },
    { name: EPlotIcon.Idle, svg: icIdle },
    { name: EPlotIcon.MovingE, svg: icMovingE },
    { name: EPlotIcon.MovingN, svg: icMovingN },
    { name: EPlotIcon.MovingNE, svg: icMovingNE },
    { name: EPlotIcon.MovingNW, svg: icMovingNW },
    { name: EPlotIcon.MovingS, svg: icMovingS },
    { name: EPlotIcon.MovingSE, svg: icMovingSE },
    { name: EPlotIcon.MovingSW, svg: icMovingSW },
    { name: EPlotIcon.MovingW, svg: icMovingW },
    { name: EPlotIcon.Private, svg: icPrivate },
    { name: 'no-vehicle-selected', svg: icNoVehicleSelected },
    { name: EPlotIcon.Towing, svg: icTowing },
    { name: EPlotIcon.LostSignal, svg: icLs },
    { name: 'signal-message', svg: icSignalMessage },
    { name: 'signal-low', svg: icSignalLow },
    { name: 'signal-lost', svg: icSignalLost },
    { name: 'signal-normal', svg: icSignalNormal },
    { name: 'no-moving', svg: icNoMoving },
    { name: 'no-idling', svg: icNoIdling },
    { name: 'no-stopped', svg: icNoStopped },
    { name: 'no-charging', svg: icNoCharging },
    { name: 'no-fleet-selected', svg: icNoFleetSelected },
    { name: 'no-fleet-connected', svg: icNoFleetConnected },
    { name: 'bolt', svg: icBolt },
    { name: 'charging', svg: icCharging },
    { name: 'charging0', svg: icCharging0 },
    { name: 'charging10', svg: icCharging10 },
    { name: 'charging20', svg: icCharging20 },
    { name: 'charging30', svg: icCharging30 },
    { name: 'charging40', svg: icCharging40 },
    { name: 'charging50', svg: icCharging50 },
    { name: 'charging60', svg: icCharging60 },
    { name: 'charging70', svg: icCharging70 },
    { name: 'charging80', svg: icCharging80 },
    { name: 'charging90', svg: icCharging90 },
    { name: 'charging99', svg: icCharging99 },
    { name: EPlotIcon.CustomerCare, svg: icCustomerCare },
    { name: 'location-pin', svg: icLocationPin },
    { name: 'wtd-availability', svg: icWtdAvailability },
    { name: 'wtd-break-due', svg: icWtdBreakDue },
    { name: 'wtd-driving', svg: icWtdDriving },
    { name: 'wtd-other-work', svg: icWtdOtherWork },
    { name: 'wtd-resting', svg: icWtdResting },
    { name: 'no-drivers-match-filter', svg: icNoDriversMatchFilter },
    { name: 'read', svg: icRead },
    { name: 'received', svg: icReceived },
    { name: 'sent', svg: icSent },
    // Places categories icons
    { name: '0', svg: ic0 },
    { name: 'AlarmClock', svg: icAlarmClock },
    { name: 'BoxClosed', svg: icBoxClosed },
    { name: 'Box', svg: icBox },
    { name: 'Brickwall', svg: icBrickwall },
    { name: 'Film', svg: icFilm },
    { name: 'Factory', svg: icFactory },
    { name: 'Earth', svg: icEarth },
    { name: 'Courthouse', svg: icCourthouse },
    { name: 'Chest', svg: icChest },
    { name: 'Fire', svg: icFire },
    { name: 'FlagRed', svg: icFlagRed },
    { name: 'FlagGreen', svg: icFlagGreen },
    { name: 'FlagYellow', svg: icFlagYellow },
    { name: 'FlagBlue', svg: icFlagBlue },
    { name: 'Key', svg: icKey },
    { name: 'FirstAid', svg: icFirstAid },
    { name: 'MailboxEmpty', svg: icMailboxEmpty },
    { name: 'Lock', svg: icLock },
    { name: 'Houses', svg: icHouses },
    { name: 'Home', svg: icHome },
    { name: 'Helicopter', svg: icHelicopter },
    { name: 'Graduate', svg: icGraduate },
    { name: 'Fortress', svg: icFortress },
    { name: 'Forklifter', svg: icForklifter },
    { name: 'Pin_Yellow', svg: icPinYellow },
    { name: 'Pin_Red', svg: icPinRed },
    { name: 'Pin_Orange', svg: icPinOrange },
    { name: 'Pin_Blue', svg: icPinBlue },
    { name: 'Pin_Grey', svg: icPinGrey },
    { name: 'Pin_Green', svg: icPinGreen },
    { name: 'PillYellow', svg: icPillYellow },
    { name: 'PillRed', svg: icPillRed },
    { name: 'PillGreen', svg: icPillGreen },
    { name: 'PillBlue', svg: icPillBlue },
    { name: 'Pawn', svg: icPawn },
    { name: 'PawnYellow', svg: icPawnYellow },
    { name: 'PawnWhite', svg: icPawnWhite },
    { name: 'PawnRed', svg: icPawnRed },
    { name: 'PawnGreen', svg: icPawnGreen },
    { name: 'PawnBlue', svg: icPawnBlue },
    { name: 'News', svg: icNews },
    { name: 'Moneybag', svg: icMoneybag },
    { name: 'Worker', svg: icWorker },
    { name: 'MobilePhone', svg: icMobilePhone },
    { name: 'Target', svg: icTarget },
    { name: 'StarYellow', svg: icStarYellow },
    { name: 'StarRed', svg: icStarRed },
    { name: 'StarGrey', svg: icStarGrey },
    { name: 'StarGreen', svg: icStarGreen },
    { name: 'StarBlue', svg: icStarBlue },
    { name: 'Shoppingcart', svg: icShoppingcart },
    { name: 'Signpost', svg: icSignpost },
    { name: 'Server', svg: icServer },
    { name: 'SatelliteDish', svg: icSatelliteDish },
    { name: 'Safe', svg: icSafe },
    { name: 'Playingcard', svg: icPlayingcard },
    { name: 'House', svg: icHouse },
    { name: 'Uncategorized', svg: icUncategorized },
    { name: EPlotIcon.Hotspot, svg: icHotSpot },
    { name: EPlotIcon.GarminStopPeding, svg: icGarminIconPending },
    { name: EPlotIcon.GarminStopEnRoute, svg: icGarminIconEnRoute },
    { name: EPlotIcon.GarminStopCompleted, svg: icGarminIconCompleted },
    { name: EPlotIcon.HarshDrivingEvent, svg: icHarshDrivingEvent },
    { name: 'copy', svg: icCopy },
    { name: EPlotIcon.MovingNPoweredAsset, svg: icMovingNPoweredAsset },
    { name: EPlotIcon.MovingNEPoweredAsset, svg: icMovingNEPoweredAsset },
    { name: EPlotIcon.MovingEPoweredAsset, svg: icMovingEPoweredAsset },
    { name: EPlotIcon.MovingSEPoweredAsset, svg: icMovingSEPoweredAsset },
    { name: EPlotIcon.MovingSPoweredAsset, svg: icMovingSPoweredAsset },
    { name: EPlotIcon.MovingSWPoweredAsset, svg: icMovingSWPoweredAsset },
    { name: EPlotIcon.MovingWPoweredAsset, svg: icMovingWPoweredAsset },
    { name: EPlotIcon.MovingNWPoweredAsset, svg: icMovingNWPoweredAsset },
    { name: EPlotIcon.IdlePoweredAsset, svg: icIdlePoweredAsset },
    { name: EPlotIcon.StoppedPoweredAsset, svg: icStopPoweredAsset },
    { name: EPlotIcon.TowingPoweredAsset, svg: icTowingPoweredAsset },
    { name: EPlotIcon.LostSignalPoweredAsset, svg: icLsPoweredAsset },
    { name: EPlotIcon.CustomerCarePoweredAsset, svg: icCustomerCarePoweredAsset },
    { name: 'close-white-with-background', svg: icCloseWhiteWithBackground },
    { name: 'video-play-button', svg: icVideoPlayButton },
    { name: EPlotIcon.LocationCheckInNonPoweredAsset, svg: icNonPoweredAssetLocationCheckIn },
    { name: EPlotIcon.StoppedNonPoweredAsset, svg: icNonPoweredAssetStopped },
    { name: EPlotIcon.MovingNENonPoweredAsset, svg: icNonPoweredAssetMovingNe },
    { name: 'replay-balloon-battery-range', svg: icReplayBalloonBatteryRange },
    { name: 'replay-segment-battery-range', svg: icReplaySegmentBatteryRange },
    { name: 'replay-segment-battery-range-info', svg: icReplaySegmentBatteryRangeInfo },
    { name: 'replay-segment-bolt', svg: icReplaySegmentBolt },
    { name: 'link', svg: icLink },
    { name: 'health-status-critical', svg: icHealthStatusCritical },
    { name: 'device-issue', svg: deviceIssue },
    { name: 'device-error-legend', svg: icDeviceWithErrorLegend },
    { name: 'no-device-error', svg: icNoDeviceError }
  ];

  constructor(
    private readonly _mapIconRegistryService: MapIconRegistryService,
    private readonly _compoundIconResgistryService: CompoundIconRegistryService
  ) {
    this._registerIcons();
    this._registerCompoundIcons();
  }
  private _registerIcons() {
    this._icons
      .map(icon => ({ name: `ic-${icon.name}`, svg: icon.svg }))
      .forEach(icon => this._mapIconRegistryService.addSvgIconByPath(icon));
  }

  private _registerCompoundIcons() {
    this._registerDeviceIssueIcons();
    this._registerChargingDeviceIssueIcons();
  }

  private _registerDeviceIssueIcons(): void {
    const deviceIssueOffset: IconOffsetParams = {
      name: `ic-${this._iconHealthStatusName}`,
      xOffset: 16,
      yOffset: -6,
      scale: 1.02
    };

    const iconsToOffsetWith = [
      // vehicles
      `ic-${EPlotIcon.MovingN}`,
      `ic-${EPlotIcon.MovingNE}`,
      `ic-${EPlotIcon.MovingE}`,
      `ic-${EPlotIcon.MovingSE}`,
      `ic-${EPlotIcon.MovingS}`,
      `ic-${EPlotIcon.MovingSW}`,
      `ic-${EPlotIcon.MovingW}`,
      `ic-${EPlotIcon.MovingNW}`,
      `ic-${EPlotIcon.Stopped}`,
      `ic-${EPlotIcon.Idle}`,
      `ic-${EPlotIcon.LostSignal}`,
      `ic-${EPlotIcon.Private}`,
      `ic-${EPlotIcon.Towing}`,
      `ic-${EPlotIcon.Panic}`,
      `ic-${EPlotIcon.Charging}`,
      // non-powered assets
      `ic-${EPlotIcon.LocationCheckInNonPoweredAsset}`,
      `ic-${EPlotIcon.MovingNENonPoweredAsset}`,
      `ic-${EPlotIcon.StoppedNonPoweredAsset}`,
      // powered assets
      `ic-${EPlotIcon.StoppedPoweredAsset}`,
      `ic-${EPlotIcon.IdlePoweredAsset}`,
      `ic-${EPlotIcon.MovingEPoweredAsset}`,
      `ic-${EPlotIcon.MovingNPoweredAsset}`,
      `ic-${EPlotIcon.MovingNEPoweredAsset}`,
      `ic-${EPlotIcon.MovingNWPoweredAsset}`,
      `ic-${EPlotIcon.MovingSPoweredAsset}`,
      `ic-${EPlotIcon.MovingSEPoweredAsset}`,
      `ic-${EPlotIcon.MovingSWPoweredAsset}`,
      `ic-${EPlotIcon.MovingWPoweredAsset}`,
      `ic-${EPlotIcon.CustomerCarePoweredAsset}`,
      `ic-${EPlotIcon.LostSignalPoweredAsset}`,
      `ic-${EPlotIcon.TowingPoweredAsset}`
    ];

    this._registerCompoundIssueIcon(deviceIssueOffset, iconsToOffsetWith);
  }

  private _registerChargingDeviceIssueIcons(): void {
    const deviceIssueOffset: IconOffsetParams = {
      name: `ic-${this._iconHealthStatusName}`,
      xOffset: 19.5,
      yOffset: -3.5,
      scale: 1.02
    };

    const iconsToOffsetWith = [
      `ic-${EPlotIcon.Charging0}`,
      `ic-${EPlotIcon.Charging10}`,
      `ic-${EPlotIcon.Charging20}`,
      `ic-${EPlotIcon.Charging30}`,
      `ic-${EPlotIcon.Charging40}`,
      `ic-${EPlotIcon.Charging50}`,
      `ic-${EPlotIcon.Charging60}`,
      `ic-${EPlotIcon.Charging70}`,
      `ic-${EPlotIcon.Charging80}`,
      `ic-${EPlotIcon.Charging90}`,
      `ic-${EPlotIcon.Charging99}`
    ];

    this._registerCompoundIssueIcon(deviceIssueOffset, iconsToOffsetWith);
  }

  private _registerCompoundIssueIcon(deviceIssueOffset: IconOffsetParams, iconsToOffsetWith: string[]) {
    const adjustViewBox: string = '0 -12.5 48 48';
    iconsToOffsetWith.forEach(icon => {
      this._compoundIconResgistryService
        .addSubIconsByName(icon, `ic-${this._iconHealthStatusName}`)
        .offsetIcon(deviceIssueOffset)
        .registerIcons(adjustViewBox);
    });
  }
}
